import { Typography } from "@mui/material";
import React from "react";
import { sectionTitleStyle } from "./sectionTitleStyles";

interface SectionTitleProps {
    children: React.ReactNode;
    mainColor?: boolean;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => {
    return (
        <Typography variant="h5" sx={sectionTitleStyle}>
            {children}
        </Typography>
    );
};

export default SectionTitle;
